module.exports = __webpack_public_path__ + "img/portraitPhone.cf61fe29.webp";